<template>
  <div class="fine-edit-modal">
    <c-sidesheet :active="displayModal" @close="onReset" @shown="onModalOpening">
      <div v-if="displayModal" class="fines-and-bonuses-create-modal edit-modal" :class="{ 'editing-mode': id }">
        <div class="fines-and-bonuses-create-modal__title">
          {{ id ? `Редактирование ${createFineOrBonus === "fine" ? "штрафа" : "премии"}` : "Добавление штрафа/премии" }}
        </div>
        <div class="fines-and-bonuses-create-modal__row">
          <div class="fines-and-bonuses-create-modal__item">
            <div class="fines-and-bonuses-create-modal__worker">
              <img :src="`${worker.photo ? worker.photo : '/redesign/img/userpic.svg'}`" alt="" class="fines-and-bonuses-create-modal__worker-photo" width="34" height="34">
              <div class="fines-and-bonuses-create-modal__worker-text">
                <div class="fines-and-bonuses-create-modal__worker-name">{{ worker.name }}</div>
                <div class="fines-and-bonuses-create-modal__worker-posts">{{ worker.posts }}</div>
                <div class="fines-and-bonuses-create-modal__worker-filial">{{ worker.filial }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!id" class="fines-and-bonuses-create-modal__row">
          <div class="fines-and-bonuses-create-modal__item">
            <c-switcher
              v-model="createFineOrBonus"
              class="h-switcher"
              type="group"
              :class="{ 'green-outline': createFineOrBonus === 'bonus' }"
              :items="[
                { label: 'Штраф', value: 'fine' },
                { label: 'Премия', value: 'bonus' },
              ]"
            />
          </div>
        </div>
        <div class="fines-and-bonuses-create-modal__row">
          <div class="fines-and-bonuses-create-modal__item">
            <c-select
              v-model="form.fineOrBonus"
              type="select"
              :floating-label="`Причина ${createFineOrBonus === 'bonus' ? 'премии' : 'штрафа'}`"
              :required-mark="true"
              :clearable="true"
              :searchable="true"
              :groups="fineOrBonusSelectGroups"
              :items="createFineOrBonus === 'bonus' ? bonusesCollection.items : finesCollection.items"
              :class="{ 'required-field': errorMessages.fineOrBonus }"
              :required="errorMessages.fineOrBonus"
              :required-condition="errorMessages.fineOrBonus"
            />
          </div>
          <div class="fines-and-bonuses-create-modal__item">
            <show-description
                v-if="createFineOrBonus === 'fine'"
                class="show-description"
                :value="form.fineOrBonus && form.fineOrBonus.value"
                :list="fineDescriptions"
                :type="'mini'"
              />
              <show-description
                v-if="createFineOrBonus === 'bonus'"
                class="show-description"
                :value="form.fineOrBonus && form.fineOrBonus.value"
                :list="bonusDescriptions"
                :type="'mini'"
              />
          </div>
        </div>
        <div class="fines-and-bonuses-create-modal__row">
          <div class="fines-and-bonuses-create-modal__item amount-input" :class="{ 'no-flex-grow': id }">
            <c-input
              v-model="form.amount"
              label="Сумма, ฿"
              placeholder="0"
              :required-mark="true"
              :clearable="true"
              type="integer-number"
              :class="{ 'required-field': errorMessages.amount }"
              :required="errorMessages.amount"
              :required-condition="errorMessages.amount"
              :max-length="12"
            />
          </div>
          <div v-if="!id" class="fines-and-bonuses-create-modal__item date-input">
            <c-input
              v-model="form.date"
              class="date-container-sm-fix"
              type="date"
              placeholder="00.00.0000"
              :label="`Дата ${createFineOrBonus === 'bonus' ? 'премии' : 'штрафа'}`"
              :icon-right="true"
              :required-mark="true"
              :clearable="true"
              icon="calendar"
              :class="{ 'required-field': errorMessages.date }"
              :required="errorMessages.date"
              :required-condition="errorMessages.date"
            />
          </div>
          <div v-if="!id" class="fines-and-bonuses-create-modal__item w-260">
            <c-input
              v-model="form.addedBy"
              type="select"
              floating-label="Выписал"
              :clearable="true"
              :searchable="true"
              :items="collections.workers"
            />
          </div>
        </div>
        <div v-if="!id" class="fines-and-bonuses-create-modal__row">
          <div class="fines-and-bonuses-create-modal__item added-by-input w-235">
            <c-input
              v-model="form.filial"
              type="select"
              floating-label="Филиал"
              :clearable="true"
              :searchable="true"
              :items="collections.filials"
              :required-mark="true"
              :class="{ 'required-field': errorMessages.filial }"
              :required="errorMessages.filial"
              :required-condition="errorMessages.filial"
              @clearInput="onFilialInputClear"
            />
          </div>
          <div v-if="!id" class="fines-and-bonuses-create-modal__item added-by-input w-260">
            <c-input
              v-model="form.position"
              type="select"
              floating-label="Должность"
              :clearable="true"
              :searchable="true"
              :items="collections.positions"
            />
          </div>
        </div>
        <div v-if="!id" class="fines-and-bonuses-create-modal__row" :class="{ 'mb-0': createFineOrBonus === 'bonus' }">
          <div class="fines-and-bonuses-create-modal__item">
            <c-input
              ref="workerInput"
              v-model="form.worker"
              type="select"
              floating-label="Сотрудник"
              :clearable="true"
              :searchable="true"
              :items="workersByFilialOrByPosition"
              :disabled="!form.filial && !form.position"
              :required-mark="true"
              :class="{ 'required-field': errorMessages.worker }"
              :required="errorMessages.worker"
              :required-condition="errorMessages.worker"
            />
          </div>
        </div>
        <div
          v-if="!id && createFineOrBonus !== 'bonus'"
          class="fines-and-bonuses-create-modal__row"
          :class="{ 'mb-0': !form.isExplanatoryRequired }"
        >
          <div class="fines-and-bonuses-create-modal__item" :class="{ 'mb-0': !form.isExplanatoryRequired }">
            <c-checkbox v-model="form.isExplanatoryRequired" label="Обязательно заполнение объяснительной" />
          </div>
        </div>
        <transition name="fade">
          <div v-if="form.isExplanatoryRequired && !id" class="fines-and-bonuses-create-modal__row mb-0">
            <div class="fines-and-bonuses-create-modal__item date-input deadline-input mb-0">
              <c-input
                v-model="form.deadline"
                type="date"
                placeholder="00.00.0000"
                label="Ответ к дате"
                icon="calendar"
                :clearable="true"
                :icon-right="true"
                :required-mark="true"
                :class="{ 'required-field': errorMessages.deadline }"
                :required="errorMessages.deadline"
                :required-condition="errorMessages.deadline"
              />
            </div>
          </div>
        </transition>

        <div class="fines-and-bonuses-create-modal__row">
          <div class="fines-and-bonuses-create-modal__item">
            <c-input
              ref="comment"
              type="textarea"
              v-model="form.comment"
              floating-label="Комментарий"
              :clearable="true"
              max-length="255"
            />
          </div>
        </div>

        <div class="fines-and-bonuses-create-modal__actions">
          <responsive-apply-reset-actions
            :fixed="!!!id"
            :disabled-but-clickable-submit="isSubmitDisabled"
            @on-submit="onSubmit"
            @on-reset="onReset"
          />
        </div>
      </div>
    </c-sidesheet>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls2/Switcher";
import Select from "@/components/controls2/Select";
import Checkbox from "@/components/checkbox";
import ResponsiveApplyResetActions from "@/components/responsive-apply-reset-actions";
import { today } from "@/constants/datePickerSelectVariants";
import { FINE_GROUP, BONUS_GROUP } from "@/constants/fineAndBonusGroups";

import { FineReasonDescription } from "@/entities/models/fine-reason";
import ShowDescription from "@/components/show-description";
import CSidesheet from "@/components/scrollable-sidesheet";
import CTextarea from "@/components/textarea";

export default {
  name: "create-modal",
  components: {
    "c-input": Input,
    "c-checkbox": Checkbox,
    "c-switcher": Switcher,
    "c-select": Select,
    ResponsiveApplyResetActions,
    ShowDescription,
    CSidesheet,
    CTextarea,
  },

  data() {
    return {
      createFineOrBonus: "fine",
      displayModal: false,
      id: null,
      recordData: {},
      form: {
        amount: "",
        addedBy: "",
        date: today,
        filial: null,
        worker: null,
        position: null,
        fineOrBonus: null,
        isExplanatoryRequired: false,
        deadline: "",
        comment: "",
      },
      errorMessages: {
        fineOrBonus: "",
        filial: "",
        date: "",
        amount: "",
        worker: "",
        deadline: "",
      },
      isOpened: false,
      isPending: false,
      worker: {
        photo: null,
        name: null,
        filial: null,
        posts: null,
      }
    };
  },
  computed: {
    ...mapState({
      collections: (state) => state.finesAndBonuses.collections,
    }),
    ...mapGetters({
      finesCollection: "finesAndBonuses/finesCollection",
      bonusesCollection: "finesAndBonuses/bonusesCollection",
      finesList: "referenceReasonsForFines/getFinesCollection",
      bonusesList: "referenceReasonsForBonuses/getBonusesCollection",
    }),
    fineDescriptions() {
      return this.finesList.map((fine) => FineReasonDescription(fine));
    },
    bonusDescriptions() {
      return this.bonusesList.map((bonus) => FineReasonDescription(bonus));
    },
    workersByFilialOrByPosition() {
      if (!this.form.filial && !this.form.position) {
        return [];
      }

      if (this.form.filial && !this.form.position) {
        return this.collections.workers.filter((worker) => {
          if (worker.filialId) {
            return worker.filialId.toString() === this.form.filial.value.toString();
          }
          return false;
        });
      }

      if (this.form.position && !this.form.filial) {
        return this.collections.workers.filter((worker) => {
          if (worker.positions.length > 0) {
            return worker.positions.some((p) => p === this.form.position.value);
          }
          return false;
        });
      }

      return this.collections.workers.filter((worker) => {
        if (worker.filialId && worker.positions.length > 0) {
          return (
            worker.filialId.toString() === this.form.filial.value.toString() &&
            worker.positions.some((p) => p === this.form.position.value)
          );
        }
        return false;
      });
    },
    isSubmitDisabled() {
      if (this.id) {
        return !this.form.fineOrBonus || !this.form.amount;
      }
      const areFieldsFilled =
        !this.form.fineOrBonus || !this.form.amount || !this.form.worker || !this.form.filial || !this.form.date;

      if (this.form.isExplanatoryRequired) {
        return areFieldsFilled || !this.form.deadline;
      }
      return areFieldsFilled;
    },
    fineOrBonusSelectGroups() {
      return this.createFineOrBonus === "bonus" ? this.bonusesCollection.groups : this.finesCollection.groups;
    },
    fineOrBonusSelectItems() {
      return this.createFineOrBonus === "bonus" ? this.bonusesCollection.items : this.finesCollection.items;
    },
  },
  watch: {
    "form.fineOrBonus": function (value) {
      if (value && this.errorMessages.fineOrBonus) {
        this.errorMessages.fineOrBonus = "";
      }
      if (this.isOpened) {
        if (value && value.amount) {
          this.form.amount = value.amount;
          return;
        } else if (this.recordData && this.recordData.sum.fineOrBonusAmountCell.amount) {
          this.form.amount = this.recordData.sum.fineOrBonusAmountCell.amount;
          return;
        }
        this.form.amount = "";
      }
    },
    "form.filial": function (value) {
      if (value && this.errorMessages.filial) {
        this.errorMessages.filial = "";
      }
      this.form.worker = null;
    },
    "form.position": async function () {
      this.form.worker = null;

      await this.$store.dispatch("finesAndBonuses/fetchFinesAndBonuses", {post: this.form.position ? this.form.position.value : "", personal_history_id: this.id})
    },
    "form.amount": function (value) {
      if (value && this.errorMessages.amount) {
        this.errorMessages.amount = "";
      }
    },
    "form.date": function (value) {
      if (value && this.errorMessages.date) {
        this.errorMessages.date = "";
      }
    },
    "form.worker": function (value) {
      if (value && this.errorMessages.worker) {
        this.errorMessages.worker = "";
      }
    },
    "form.deadline": function (value) {
      if (value && this.errorMessages.deadline) {
        this.errorMessages.deadline = "";
      }
    },
    "createFineOrBonus": function () {
      if (this.id) {
        return;
      }

      this.form.fineOrBonus = null;
      this.form.amount = "";
    },
  },
  methods: {
    validate() {
      let isValid = true;
      if (!this.form.fineOrBonus) {
        this.errorMessages.fineOrBonus = "Обязательное поле";
        isValid = false;
      }
      if (!this.form.amount) {
        this.errorMessages.amount = "Обязательное поле";
        isValid = false;
      }
      if (Number(this.form.amount) === 0) {
        this.errorMessages.amount = "Введите сумму больше нуля";
        isValid = false;
      }
      if (this.id) {
        return isValid;
      }
      if (!this.form.date) {
        this.errorMessages.date = "Обязательное поле";
        isValid = false;
      }
      if (!this.form.filial) {
        this.errorMessages.filial = "Обязательное поле";
        isValid = false;
      }
      if (!this.form.worker) {
        this.errorMessages.worker = "Обязательное поле";
        isValid = false;
      }
      if (!this.form.isExplanatoryRequired) {
        return isValid;
      }
      if (!this.form.deadline) {
        this.errorMessages.deadline = "Обязательное поле";
        isValid = false;
      }
      return isValid;
    },
    async onSubmit() {
      if (this.isPending) {
        return;
      }

      if (!this.validate()) {
        return;
      }

      if (this.isSubmitDisabled) {
        return;
      }

      this.isPending = true;

      if (this.id) {
        try {
          const { success } = await this.$store.dispatch("finesAndBonuses/updateFineOrBonus", {
            ...this.form,
            createFineOrBonus: this.createFineOrBonus,

            id: this.id,
          });
          if (success) {
            this.isPending = false;
            this.onReset();

            this.$notify({
              group: "success-message",
              data: {
                  textMessage: `Финансовая проводка обновлена`,
              },
            });
          }
        } catch {
          this.isPending = false;

          this.$notify({
            group: "error-message",
            data: {
                textMessage: `Произошла ошибка. Попробуйте ещё раз.`,
            },
          });
        }
        return;
      }
      try {
        const { success } = await this.$store.dispatch("finesAndBonuses/createFineOrBonus", {
          ...this.form,
          createFineOrBonus: this.createFineOrBonus,
        });
        if (success) {
          this.isPending = false;
          this.onReset();
        }
      } catch {
        this.isPending = false;
      }
    },
    onReset() {
      this.$emit('close');
      this.isOpened = false;
      this.displayModal = false;
      setTimeout(() => {
        this.form.date = today;
        this.form.filial = null;
        this.form.worker = null;
        this.form.fineOrBonus = null;
        this.form.isExplanatoryRequired = false;
        this.form.deadline = "";
        this.form.amount = "";

        this.form.comment = '';
        if (this.$refs.comment) {
          this.$refs.comment.setValue('')

          this.$refs.comment.textValue = '';
          this.$refs.comment.$refs.textareaValue.innerHTML = '';
        }
        this.errorMessages = {
          fineOrBonus: "",
          filial: "",
          date: "",
          amount: "",
          worker: "",
        };
        this.createFineOrBonus = "fine";
        this.id = null;
      }, 100);
    },
    open(data = {}) {
      if (data.id) {
        this.recordData = data;
        console.log('data', data)
        this.id = data.id.value;
        this.form.date = data.date.value;
        this.form.filial = this.collections.filials.find((filial) => filial.value === data.filial.id);
        this.form.worker = this.collections.workers.find((worker) => worker.value === data.fio.fineOrBonusFullNameCell.workerId);
        this.form.position = {
          value: data.post_code.value
        }
        this.form.isExplanatoryRequired = data.doesRequireExplanatory;
        this.form.deadline = data.deadline.fineOrBonusDeadlineCell.deadline;
        this.form.amount = data.sum.fineOrBonusAmountCell.amount;

        setTimeout(() => {
          this.form.comment = data.comment.value;
          this.$refs.comment.setValue(data.comment.value);
          this.$refs.comment.textValue = data.comment.value;
          this.$refs.comment.$refs.textareaValue.innerHTML = data.comment.value;
        }, 100);

        console.log(data.type)
        if (data.type.toString() === "0") {
          this.createFineOrBonus = "fine";
          this.form.fineOrBonus = this.finesCollection.items.find((i) => i.value.toString() === data.typeId.toString());
          //console.log("fine:", this.form.fineOrBonus, data.typeId, this.finesCollection.items);
          if (!this.form.fineOrBonus) {
            this.form.fineOrBonus = this.finesCollection.deletedItems.find(
              (i) => i.value.toString() === data.typeId.toString(),
            );
          }
        }

        console.log(this.createFineOrBonus, '!!!!!!!!!')

        if (data.type.toString() === "1" /*BONUS_GROUP.toString()*/) {
          this.createFineOrBonus = "bonus";
          this.form.fineOrBonus = this.bonusesCollection.items.find(
            (i) => i.value.toString() === data.typeId.toString(),
          );
          if (!this.form.fineOrBonus) {
            this.form.fineOrBonus = this.bonusesCollection.deletedItems.find(
              (i) => i.value.toString() === data.typeId.toString(),
            );
          }
        }

        const worker = this.collections.workers.find(worker => worker.value === data.worker_id)

        if (worker) {
          this.worker = {
            photo: worker.photo, 
            name: worker.label, 
            filial: worker.filial_name, 
            posts: worker.post_names
          }
        }
      }
      setTimeout(() => {
        this.isOpened = true;
        this.displayModal = true;
      }, 0);
    },
    onFilialInputClear() {
      this.$refs.workerInput.clear();
    },
    onModalOpening() {
      if (document.body.offsetWidth < 478) {
        const modalBody = document.querySelector(".modal-body");
        if (this.id) {
          modalBody.style.height = "auto";
        } else {
          modalBody.style.height = "100vh";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.show-description {
  /deep/ {
    .show-description-modal {
      position: relative;
      z-index: 9999;
    }
  }
}

.fines-and-bonuses-create-modal {
  &__worker {
    display: flex;

    &-photo {
      margin-right: 10px;
    }
    &-text {
      font-weight: 500;
      font-size: 15px;
      line-height: 110%;
    }
    &-name {
    }
    &-posts {
      font-size: 13px;
      line-height: 120%;
    }
    &-filial {
      font-size: 13px;
      line-height: 120%;
      color: #8E9CBB;
    }
  }

  @include onlyExtraSmall {
    padding-bottom: 70px;
    &.editing-mode {
      padding-bottom: 0;
    }
  }
  &__close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  &__title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;

    @include onlyExtraSmall {
      font-size: 15px;
    }
  }
  &__row {
    display: flex;
    margin-bottom: 25px;
    gap: 30px;

    @include onlyExtraSmall {
      flex-wrap: wrap;
      gap: 15px;
    }
  }
  &__item {
    flex-grow: 1;
    max-width: 564px;

    &.amount-input {
      width: 170px;
    }
    &.date-input {
      width: 125px;
    }
    &.deadline-input {
      flex-grow: 0;
    }
    @include onlyStandartMobile {
      width: 100%;

      &.amount-input,
      &.date-input {
        width: 132px;
        flex-grow: 0;
      }
    }
  }
  &__actions {
    display: flex;
    @include onlyExtraSmall {
      margin-right: -20px;
    }

    @include vp-767 {
      position: fixed;
      bottom: 0;
    }
  }

  .show-description {
    margin-top: 12px;
  }
}
.mb-0 {
  margin-bottom: 0;
}
.green-outline {
  & /deep/ .c-switcher-group-item_active:after {
    border-color: $color-success !important;
  }
}
.w-235 {
  width: 235px;
}
.w-260 {
  width: 260px;
}
::v-deep .modal-dialog {
  max-width: 590px;
}
::v-deep .modal-body {
  padding: 22px 31px 30px 34px;
  @media (max-width: 700px) {
    padding: 20px 20px 70px;
    overflow-y: auto;
    height: 100vh;
  }
  @include onlyExtraSmall {
    padding: 20px 20px 0px;
  }
}
.no-flex-grow {
  flex-grow: 0;
}
@include onlyStandartMobile {
  ::v-deep .modal-content {
    height: auto;
  }
  ::v-deep .modal-body {
    padding-bottom: 0;
  }
}
::v-deep .responsive-actions {
  margin-top: 25px;
}
.date-container-sm-fix ::v-deep .c-input-container_date {
  @include onlyStandartMobile {
    left: -148px;
  }
}
.required-field {
  margin-bottom: 20px;
}

/deep/ {
  .modal-frame__header {
    margin-bottom: 0;
  }
}
</style>
